/**
 * Shared utilities for CSV generation/download and print handling.
 */

/** Escape a single CSV cell value. */
function escapeCsvCell(val) {
  const s = val === null || val === undefined ? '' : String(val);
  if (s.includes('"') || s.includes(',') || s.includes('\n') || s.includes('\r')) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

/** Convert an array of row objects + header keys into a CSV string. */
export function buildCsv(rows, columns) {
  const header = columns.map((c) => escapeCsvCell(c.label || c.key)).join(',');
  const body = rows.map((row) =>
    columns.map((c) => {
      const val = typeof c.get === 'function' ? c.get(row) : row[c.key];
      return escapeCsvCell(val);
    }).join(',')
  );
  return [header, ...body].join('\r\n');
}

/** Trigger a browser CSV download. */
export function downloadCsv(rows, columns, filename) {
  const csv = buildCsv(rows, columns);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'report.csv';
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 100);
}

/** Generate a filename with today's date appended. */
export function reportFilename(name) {
  const d = new Date().toISOString().slice(0, 10);
  return `${name}-${d}.csv`;
}

/** Print the element(s) with the given CSS class by temporarily hiding everything else. */
export function printReport(printAreaId) {
  window.print();
}

/** Return true if the string is non-empty and not "none" (case-insensitive). */
export function hasContent(val) {
  const s = String(val || '').trim();
  return s !== '' && s.toLowerCase() !== 'none';
}

/** Return '✓' if hasContent(val), else ''. */
export function flagContent(val) {
  return hasContent(val) ? '✓' : '';
}
